import { render, staticRenderFns } from "./NeedWallet.vue?vue&type=template&id=38aba8d2&scoped=true"
import script from "./NeedWallet.vue?vue&type=script&lang=js"
export * from "./NeedWallet.vue?vue&type=script&lang=js"
import style0 from "./NeedWallet.vue?vue&type=style&index=0&id=38aba8d2&prod&scoped=true&lang=css"
import style1 from "./NeedWallet.vue?vue&type=style&index=1&id=38aba8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aba8d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VDialog,VExpandTransition,VIcon,VImg,VLayout})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
